import { heroData, statsData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20grand%20modern%20Chinese%20corporate%20headquarters%20building%20architecture%20at%20golden%20hour%2C%20warm%20elegant%20atmosphere%2C%20clean%20minimalist%20design%2C%20soft%20gradient%20sky%2C%20professional%20corporate%20style%2C%20beige%20and%20gold%20tones%2C%20no%20people%2C%20abstract%20geometric%20architecture%2C%20high%20quality%20rendering&width=1920&height=1080&seq=nangong-hero-bg&orientation=landscape"
          alt="南宫集团总部"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-20">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-6 tracking-wide">
            {heroData.title}
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-4 font-heading tracking-wider">
            {heroData.subtitle}
          </p>
          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              {heroData.ctaPrimary}
              <i className="ri-download-2-line ml-2"></i>
            </a>
            <a
              href="#about-brief"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full text-base hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/30"
            >
              {heroData.ctaSecondary}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {statsData.map((stat, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-5 md:px-6 md:py-6 border border-white/20"
            >
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}